const endpoints = [
  { method: "GET", path: "/api/v1/me", description: "Mandant zum verwendeten Key" },
  { method: "GET", path: "/api/v1/products", description: "Produkte des Mandanten" },
  { method: "POST", path: "/api/v1/products", description: "Produkt anlegen" },
  { method: "GET", path: "/api/v1/products/:id", description: "Einzelnes Produkt" },
  { method: "PATCH", path: "/api/v1/products/:id", description: "Produkt ändern" },
  { method: "DELETE", path: "/api/v1/products/:id", description: "Produkt löschen" },
];

const statusCodes = [
  { code: "401", meaning: "Token fehlt, ist ungültig oder wurde widerrufen" },
  { code: "403", meaning: "Mandant ist gesperrt" },
  { code: "429", meaning: "Rate-Limit des Mandanten überschritten" },
];

export function ApiDocsPage() {
  const origin = window.location.origin;

  return (
    <section>
      <h1>Öffentliche API</h1>
      <p className="muted">
        Authentifizierung über den API-Key des Mandanten im <code>Authorization</code>-Header.
        Keys werden pro Mandant im jeweiligen Detailbereich erstellt.
      </p>

      <h2>Beispiel</h2>
      <pre className="code-block">
{`curl ${origin}/api/v1/products \\
  -H "Authorization: Bearer ock_live_…"`}
      </pre>

      <h2>Endpunkte</h2>
      <table className="table">
        <thead>
          <tr>
            <th>Methode</th>
            <th>Pfad</th>
            <th>Beschreibung</th>
          </tr>
        </thead>
        <tbody>
          {endpoints.map((endpoint) => (
            <tr key={`${endpoint.method} ${endpoint.path}`}>
              <td>
                <code>{endpoint.method}</code>
              </td>
              <td>
                <code>{endpoint.path}</code>
              </td>
              <td>{endpoint.description}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h2>Fehlercodes</h2>
      <table className="table">
        <thead>
          <tr>
            <th>Status</th>
            <th>Bedeutung</th>
          </tr>
        </thead>
        <tbody>
          {statusCodes.map((status) => (
            <tr key={status.code}>
              <td>
                <code>{status.code}</code>
              </td>
              <td>{status.meaning}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <p className="muted small">
        Jede Antwort enthält <code>X-RateLimit-Limit</code>, <code>X-RateLimit-Remaining</code>{" "}
        und <code>X-RateLimit-Reset</code>.
      </p>
    </section>
  );
}
